import {
  GET_DSP_USER_LIST,
  GET_ADMIN_DSP_USER_LIST,
  CHANGE_STATUS,
  CHANGE_STATUS_SALES,
  CHANGE_STATUS_RETAILER,
  DELETE_PROFILE_DETAILS,
  DELETE_PROFILE_SALES,
  DELETE_PROFILE_RETAILER,
  UPADTE_ADMIN_CUSTOMER,
  UPADTE_SALES_CUSTOMER,
  UPADTE_RETAILER_CUSTOMER,
  GET_DSP_USER,
  GET_ADMIN_USER_1,
  GET_DSP_USER_1,
  GET_DSP_USER_RETAILER,
  INSERT_PROFILE,
  GET_DSP_USER_ASM,
  CHANGE_STATUS_ASM,
  DELETE_PROFILE_ASM,
  SET_USER_ADD_PERMISSION,
} from 'redux/admin-constants';

const initialState = {
  dspUserList: [],
  adminDspUserList: [],
  dspUserDetails: [],
  childUserDetails: [],
  childRetailerUserDetails: [],
  childASMUserDetails: [],
  adminuser: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_DSP_USER_LIST: {
      return {
        ...state,
        dspUserList: payload,
      };
    }
    case GET_ADMIN_DSP_USER_LIST: {
      return {
        ...state,
        adminDspUserList: payload,
      };
    }
    case CHANGE_STATUS: {
      return {
        ...state,
        dspUserList: state.dspUserList.map((item) =>
          item.user_id === parseInt(payload.userid)
            ? { ...item, ...payload }
            : item
        ),
        adminDspUserList: state.adminDspUserList.map((item) =>
          item.user_id === parseInt(payload.userid)
            ? { ...item, ...payload }
            : item
        ),
      };
    }
    case CHANGE_STATUS_SALES: {
      return {
        ...state,
        childUserDetails: state.childUserDetails.map((item) =>
          item.user_id === parseInt(payload.userid)
            ? { ...item, ...payload }
            : item
        ),
        dspUserList: state.dspUserList.map((item) =>
          item.user_id === parseInt(payload.userid)
            ? { ...item, ...payload }
            : item
        ),
        adminDspUserList: state.adminDspUserList.map((item) =>
          item.user_id === parseInt(payload.userid)
            ? { ...item, ...payload }
            : item
        ),
      };
    }
    case CHANGE_STATUS_RETAILER: {
      return {
        ...state,
        childRetailerUserDetails: state.childRetailerUserDetails.map((item) =>
          item.user_id === parseInt(payload.userid)
            ? { ...item, ...payload }
            : item
        ),
        dspUserList: state.dspUserList.map((item) =>
          item.user_id === parseInt(payload.userid)
            ? { ...item, ...payload }
            : item
        ),
        adminDspUserList: state.adminDspUserList.map((item) =>
          item.user_id === parseInt(payload.userid)
            ? { ...item, ...payload }
            : item
        ),
      };
    }
    case CHANGE_STATUS_ASM: {
      return {
        ...state,
        childASMUserDetails: state.childASMUserDetails.map((item) =>
          item.user_id === parseInt(payload.userid)
            ? { ...item, ...payload }
            : item
        ),
        dspUserList: state.dspUserList.map((item) =>
          item.user_id === parseInt(payload.userid)
            ? { ...item, ...payload }
            : item
        ),
        adminDspUserList: state.adminDspUserList.map((item) =>
          item.user_id === parseInt(payload.userid)
            ? { ...item, ...payload }
            : item
        ),
      };
    }
    case DELETE_PROFILE_DETAILS: {
      const updatedUserList = state.dspUserList.filter(
        (item) => item.user_id !== parseInt(payload.userid)
      );
      const updatedAdminUserList = state.adminDspUserList.filter(
        (item) => item.user_id !== parseInt(payload.userid)
      );
      return {
        ...state,
        dspUserList: updatedUserList,
        adminDspUserList: updatedAdminUserList,
      };
    }
    case DELETE_PROFILE_SALES: {
      const updatedUserList1 = state.childUserDetails.filter(
        (item) => item.user_id !== parseInt(payload.userid)
      );
      return {
        ...state,
        childUserDetails: updatedUserList1,
        dspUserList: state.dspUserList.filter(
          (item) => item.user_id !== parseInt(payload.userid)
        ),
        adminDspUserList: state.adminDspUserList.filter(
          (item) => item.user_id !== parseInt(payload.userid)
        ),
      };
    }
    case DELETE_PROFILE_RETAILER: {
      const updatedUserList2 = state.childRetailerUserDetails.filter(
        (item) => item.user_id !== parseInt(payload.userid)
      );
      return {
        ...state,
        childRetailerUserDetails: updatedUserList2,
        dspUserList: state.dspUserList.filter(
          (item) => item.user_id !== parseInt(payload.userid)
        ),
        adminDspUserList: state.adminDspUserList.filter(
          (item) => item.user_id !== parseInt(payload.userid)
        ),
      };
    }
    case DELETE_PROFILE_ASM: {
      const updatedUserList3 = state.childASMUserDetails.filter(
        (item) => item.user_id !== parseInt(payload.userid)
      );
      return {
        ...state,
        childASMUserDetails: updatedUserList3,
        dspUserList: state.dspUserList.filter(
          (item) => item.user_id !== parseInt(payload.userid)
        ),
        adminDspUserList: state.adminDspUserList.filter(
          (item) => item.user_id !== parseInt(payload.userid)
        ),
      };
    }

    case UPADTE_ADMIN_CUSTOMER:
      return {
        ...state,
        dspUserList: state.dspUserList.map((item) =>
          item.user_id === parseInt(payload[0].user_id)
            ? { ...item, ...payload[0] }
            : item
        ),
        adminDspUserList: state.adminDspUserList.map((item) =>
          item.user_id === parseInt(payload[0].user_id)
            ? { ...item, ...payload[0] }
            : item
        ),
        childUserDetails: state.childUserDetails.map((item) =>
          item.user_id === parseInt(payload[0].user_id)
            ? { ...item, ...payload[0] }
            : item
        ),
        childRetailerUserDetails: state.childRetailerUserDetails.map((item) =>
          item.user_id === parseInt(payload[0].user_id)
            ? { ...item, ...payload[0] }
            : item
        ),
        childASMUserDetails: state.childASMUserDetails.map((item) =>
          item.user_id === parseInt(payload[0].user_id)
            ? { ...item, ...payload[0] }
            : item
        ),
      };

    case GET_DSP_USER: {
      return {
        ...state,
        dspUserDetails: payload,
      };
    }

    case GET_DSP_USER_1: {
      return {
        ...state,
        childUserDetails: payload,
      };
    }
    case GET_DSP_USER_RETAILER: {
      return {
        ...state,
        childRetailerUserDetails: payload,
      };
    }
    case GET_DSP_USER_ASM: {
      return {
        ...state,
        childASMUserDetails: payload,
      };
    }
    case GET_ADMIN_USER_1: {
      return {
        ...state,
        adminuser: payload,
      };
    }

    case INSERT_PROFILE: {
      return { ...state, dspUserDetails: [payload, ...state.dspUserDetails] };
    }

    case SET_USER_ADD_PERMISSION: {
      const targetUserId = parseInt(payload.userID);
      const permVal = parseInt(payload.permissionValue);
      return {
        ...state,
        childUserDetails: state.childUserDetails.map((item) =>
          item.user_id === targetUserId
            ? { ...item, is_adduser: permVal, can_add_user: permVal, permissionValue: permVal }
            : item
        ),
        dspUserList: state.dspUserList.map((item) =>
          item.user_id === targetUserId
            ? { ...item, is_adduser: permVal, can_add_user: permVal, permissionValue: permVal }
            : item
        ),
        adminDspUserList: state.adminDspUserList.map((item) =>
          item.user_id === targetUserId
            ? { ...item, is_adduser: permVal, can_add_user: permVal, permissionValue: permVal }
            : item
        ),
      };
    }

    default:
      return state;
  }
};

export default reducer;